import axios from 'axios'
import { API_CONFIG } from '@/config/api'
import { tokenService } from '../auth/token.service'
import type { ApplicationConfiguration } from './models'

/**
 * 配置服务类
 * 处理应用配置相关的功能
 */
export class ConfigService {
  private readonly CONFIG_ENDPOINT = `${API_CONFIG.baseURL}/api/abp/application-configuration`

  /**
   * 获取应用配置（包含当前用户信息）
   * @param accessToken 访问令牌（可选）
   * @returns 应用配置
   */
  async getApplicationConfiguration(accessToken?: string): Promise<ApplicationConfiguration> {
    try {
      // 如果没有传入 accessToken，尝试从 tokenService 获取
      const token = accessToken || tokenService.getAccessToken()

      // 使用原始 axios 避免 401 响应触发全局拦截器的重定向逻辑
      // 并确保始终手动设置 Authorization header
      const headers: Record<string, string> = {}
      if (token) {
        headers['Authorization'] = `Bearer ${token}`
      }

      const response = await axios.get<ApplicationConfiguration>(
        `${this.CONFIG_ENDPOINT}?IncludeLocalizationResources=false`,
        {
          withCredentials: true,
          headers
        }
      )

      return response.data
    } catch (error) {
      console.error('Failed to get application configuration:', error)
      throw error
    }
  }
}

// 创建单例实例
export const configService = new ConfigService()
